import { render, staticRenderFns } from "./BuyingGuides.vue?vue&type=template&id=2e529fc6&"
import script from "./BuyingGuides.vue?vue&type=script&lang=js&"
export * from "./BuyingGuides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports